/**
 * Gallery Global Store - API and data loading state
 */

import { ErrorService } from '../services/error-service.js';

export function createGalleryGlobalStore() {
  return {
    loading: false,
    last_updated: null,
    collections_loaded: false,

    setLoading(loading) {
      this.loading = loading;
    },

    setError(error, context = 'API') {
      if (error) {
        const formatted = ErrorService.formatError(error, context);
        formatted.type = ErrorService.ERROR_TYPES.NETWORK; // API errors are usually network-related
        ErrorService.logError(formatted, context);
      }
    },

    clearError() {
      this.error = null;
    },

    setCollectionsLoaded(loaded) {
      this.collections_loaded = loaded;
      if (loaded) {
        this.last_updated = Date.now();
      }
    },

    get hasError() {
      return this.error !== null;
    },

    get isReady() {
      return this.collections_loaded && !this.loading && !this.hasError;
    },

    get loadingState() {
      if (this.loading) return 'loading';
      if (this.hasError) return 'error';
      if (this.collections_loaded) return 'ready';
      return 'initial';
    },

    getLastUpdatedTime() {
      if (!this.last_updated) return null;

      const now = Date.now();
      const diff = now - this.last_updated;
      const minutes = Math.floor(diff / 60000);

      if (minutes < 1) return 'Just now';
      if (minutes === 1) return '1 minute ago';
      if (minutes < 60) return `${minutes} minutes ago`;

      const hours = Math.floor(minutes / 60);
      if (hours === 1) return '1 hour ago';
      if (hours < 24) return `${hours} hours ago`;

      const days = Math.floor(hours / 24);
      if (days === 1) return '1 day ago';
      return `${days} days ago`;
    },

    resetState() {
      this.loading = false;
      this.error = null;
      this.last_updated = null;
      this.collections_loaded = false;
    }
  };
}